import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const badge = cva(
  "inline-flex items-center gap-1 rounded-xs px-1.5 py-0.5 text-2xs font-semibold uppercase tracking-[0.04em] whitespace-nowrap leading-none",
  {
    variants: {
      tone: {
        neutral: "bg-sunken text-ink-soft",
        brand: "bg-brand-tint text-brand-ink",
        brass: "bg-[color:var(--color-brass-tint)] text-[color:var(--color-brass)]",
        ok: "bg-ok-tint text-ok",
        warn: "bg-warn-tint text-warn",
        danger: "bg-danger-tint text-danger",
        info: "bg-info-tint text-info",
      },
      outline: {
        true: "bg-transparent ring-1 ring-inset",
        false: "",
      },
    },
    compoundVariants: [
      { tone: "neutral", outline: true, class: "ring-line-strong text-ink-soft" },
      { tone: "ok", outline: true, class: "ring-[color:var(--color-ok)]/35" },
      { tone: "warn", outline: true, class: "ring-[color:var(--color-warn)]/35" },
      { tone: "danger", outline: true, class: "ring-[color:var(--color-danger)]/35" },
      { tone: "info", outline: true, class: "ring-[color:var(--color-info)]/35" },
      { tone: "brand", outline: true, class: "ring-[color:var(--color-brand)]/30" },
    ],
    defaultVariants: { tone: "neutral", outline: false },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badge> {}

export function Badge({ className, tone, outline, ...props }: BadgeProps) {
  return <span className={cn(badge({ tone, outline }), className)} {...props} />;
}
